import React from 'react';
import {
    CalendarOutlined,
    WarningOutlined,
    LockOutlined,
} from '@ant-design/icons';
import { Card } from '@clockout-dev/design-elements';
import styles from './styles/eligibilitySummaryCard.module.scss';
import Inherit from '../../../../core/inherit';
import EiligibilitySummaryCardHeader from './elements/EligibilitySummaryCardHeader';
import EiligibilitySummaryContent from './elements/EligibilitySummaryCardBody';
import EiligibilitySummaryCardKpi from './elements/EligibilitySummaryCardKpi';

const DEFAULT_SUMMARY = {
    mode: 'restricted',
    status: 'low',
    minTenure: 'Not Set',
    riskFactor: 'Not Set',
    overdraftThreshold: 'Not Set',
    nsfThreshold: 'Not Set',
    negativeBalanceDays: 'Not Set',
    employerTenure: 'Not Set',
};

class EligibilitySummaryCard extends Inherit(React.Component) {
    render() {
        const { data } = this.props;
        const summary = {
            ...DEFAULT_SUMMARY,
            ...data,
        };

        return (
            <Card className={styles.summaryCard}>
                <EiligibilitySummaryCardHeader />

                <EiligibilitySummaryCardKpi status={summary.status} />

                <div className={styles.kpiList}>
                    <EiligibilitySummaryContent title="System Mode" value={summary.mode?.charAt(0).toUpperCase() + summary.mode?.slice(1)} icon={<LockOutlined />} />
                    <EiligibilitySummaryContent title="Min Tenure" value={summary.minTenure} icon={<CalendarOutlined />} />
                    {summary.riskFactor !== 'Not Set' && (
                        <EiligibilitySummaryContent title="Risk Factors" value={summary.riskFactor} icon={<WarningOutlined />} />
                    )}
                    {summary.overdraftThreshold !== 'Not Set' && (
                        <EiligibilitySummaryContent title="Overdraft Threshold" value={summary.overdraftThreshold} icon={<WarningOutlined />} />
                    )}
                    {summary.nsfThreshold !== 'Not Set' && (
                        <EiligibilitySummaryContent title="NSF Threshold" value={summary.nsfThreshold} icon={<WarningOutlined />} />
                    )}
                    {summary.negativeBalanceDays !== 'Not Set' && (
                        <EiligibilitySummaryContent title="Negative Balance" value={summary.negativeBalanceDays} icon={<WarningOutlined />} />
                    )}
                    {summary.employerTenure !== 'Not Set' && (
                        <EiligibilitySummaryContent title="Employer Tenure" value={summary.employerTenure} icon={<CalendarOutlined />} />
                    )}
                </div>
            </Card>
        );
    }
};

export default EligibilitySummaryCard;
